import {Controller} from "stimulus"
import $ from 'jquery';

import 'toastr/toastr.scss'
import 'sweetalert2/dist/sweetalert2.css'
// import '@sweetalert2/themes/default/default.scss';


export default class extends Controller {

    static values = {}

    connect() {
        let tabCount = 0;

        // Función para actualizar el contador en el DOM y localStorage
        function updateCounter(count) {
            tabCount = count;
            localStorage.setItem("tabCount", count);

            // Disparamos un evento personalizado para la pestaña actual
            window.dispatchEvent(
                new CustomEvent("localStorageChange", {
                    detail: { count },
                }),
            );
        }

        // Al cargar la página
        window.addEventListener("load", () => {
            // Obtenemos el contador actual o lo inicializamos
            const storedCount =
                parseInt(localStorage.getItem("tabCount")) || 0;
            updateCounter(storedCount + 1);
        });

        // Al cerrar la pestaña
        window.addEventListener("beforeunload", () => {
            updateCounter(Math.max(0, tabCount - 1));
        });

        // Escuchamos cambios en el localStorage (de otras pestañas)
        window.addEventListener("storage", (event) => {
            // if (event.key === 'tabCount') {
            updateCounter(parseInt(event.newValue) || 0);
            // }
        });

        // Sincronización inicial
        function syncCounter() {
            const storedCount =
                parseInt(localStorage.getItem("tabCount")) || 0;
            if (storedCount !== tabCount) {
                updateCounter(storedCount);
            }
        }

        setInterval(syncCounter, 1000);
    }
}